import { Component } from '@angular/core';

import { ContactType } from '@camelot/services';
import { ContactTypeComponent } from '@camelot/ui';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-contact-types-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [ContactTypeComponent],
  template: `
    <div class="simple-flex align-center g-space-xs" style="height: 100%">
      @for (contactType of this.value; track contactType) {
        <cam-contact-type class="d-flex" [contactType]="contactType"></cam-contact-type>
      }
    </div>
  `,
})
export class GridContactTypesCellComponent extends AbstractCellComponent<any, ContactType[]> {}
